import { useEffect, type ReactNode } from 'react';
import { useNavigate } from 'react-router-dom';

import { DASHBOARD_PATH } from '../../config';
import useAuth from '../../hooks/useAuth';

interface GuestGuardProps {
  children: ReactNode;
}

const GuestGuard = ({ children }: GuestGuardProps) => {
  const { isAuthenticated } = useAuth();
  const navigate = useNavigate();

  useEffect(() => {
    if (isAuthenticated) {
      navigate(DASHBOARD_PATH, { replace: true });
    }
  }, [isAuthenticated, navigate]);

  return <>{children}</>;
};

export default GuestGuard;